export { default } from "./InputPassword"
